<script type="text/ecmascript-6">
    import DesignerQuestionDoorColourExternal from "../DesignerQuestionDoorColourExternal.vue";
    import SynsealTileQuestion from "../mixin/synseal/TileQuestion.vue";

    export default {
        mixins: [
            DesignerQuestionDoorColourExternal,
            SynsealTileQuestion,
        ],
        props: {
            isCraftsman: {
                required: true
            }
        },
        computed: {
            thumbURL(){
                if (this.isCraftsman) {
                    return '/thumb/door-colour-2/';
                }
                return '/thumb/door-colour-' + this.frameMaterial + '/';
            },
        }
    }
</script>
